import React, { useEffect, useState } from 'react';
import useScreen from 'src/hooks/useScreen';
import queryString from 'query-string';
import PermissionsProvider from 'src/providers/PermissionsProvider';
import useBreadcrumb from 'src/hooks/useBreadcrumb';
import useTheme from 'src/hooks/useTheme';
import TitleBar from 'src/components/layout/TitleBar';
import { LuUsers2 } from 'react-icons/lu';
import { Space, Switch, notification } from 'antd';
import Splitter, { SplitDirection } from '@devbookhq/splitter';
import UsersEditor from './Components/UserEditor';
import UsersSelector from './Components/UserSelector';
import { FaPlus } from 'react-icons/fa6';
import StyledButton from 'src/components/layout/StyledButton';
import UserCreate from './Components/UserCreate';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import { postUserCognito } from 'src/api/users';
import useMasterAdmin from 'src/hooks/useMasterAdmin';
import WhenDesktop from 'src/components/layout/WhenDesktop';

//import PropTypes from 'prop-types';

const MasterAdminUsers = () => {
  const { userId } = queryString.parse(window.location.search);

  const { executeAsyncProcess } = useAsyncProcesses();
  const { setBreadcrumb, dropBreadcrumb } = useBreadcrumb();
  const { theme } = useTheme();
  const { updateUser, addNewCreatedUser, deleteUser } = useMasterAdmin();
  const { isDesktop } = useScreen();

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [newUserOpen, setNewUserOpen] = useState(false);
  const [layoutHorizontal, setLayoutHorizontal] = useState(isDesktop);

  useEffect(() => {
    setBreadcrumb([
      {
        title: 'Master Admin',
        path: '/master-admin',
      },
      {
        title: 'Users',
      },
    ]);

    return () => {
      dropBreadcrumb();
    };
  }, []);

  useEffect(() => {
    console.log('selectedUserId', selectedUserId);
  }, [selectedUserId]);

  const handleUserCreateOnSubmit = (values) => {
    console.log('handleUserCreateOnSubmit', values);
    setNewUserOpen(false);
    executeAsyncProcess(async () => {
      try {
        const resp = await postUserCognito(values);
        console.log('resp', resp); // TODO: show new user in the list
        addNewCreatedUser(resp.user);
        notification.success({
          message: 'Success',
          description: <>Data has been saved</>,
          duration: 5,
        });
      } catch (error) {
        console.log(error);
      }
    });
  };

  const handleUserEditorOnSave = (user) => {
    console.log('handleUserEditorOnSave', user);
    const { name: user_name, disabled: user_disabled } = user;
    updateUser(user.id, { user_name, user_disabled });
  };

  const handleUserEditorOnDelete = (id) => {
    console.log('handleUserEditorOnDelete', id);
    deleteUser(id);
    setSelectedUserId(null);
  };

  return (
    <PermissionsProvider requiredPermissions={['admin.master']}>
      <UserCreate open={newUserOpen} onClose={() => setNewUserOpen(false)} onSubmit={handleUserCreateOnSubmit} />
      <TitleBar
        title={
          <Space className='btn'>
            <LuUsers2 />
            Users
          </Space>
        }
        afterTitleExtras={
          <>
            {!userId && (
              <StyledButton color={theme.textBase} onClick={() => setNewUserOpen(true)} size='small'>
                <Space className='btn'>
                  <FaPlus />
                  <WhenDesktop>Create user</WhenDesktop>
                </Space>
              </StyledButton>
            )}
          </>
        }
      >
        <Space>
          <Switch
            unCheckedChildren={<>vertical</>}
            checkedChildren={<>horizontal</>}
            checked={layoutHorizontal}
            onChange={() => {
              setLayoutHorizontal(!layoutHorizontal);
            }}
          />
        </Space>
      </TitleBar>
      <div className='p-4 h-full max-h-full w-full overflow-hidden'>
        <Splitter direction={layoutHorizontal ? SplitDirection.Horizontal : SplitDirection.Vertical}>
          <div className={'overflow-hidden h-full max-h-full w-full  p-4'} style={{ backgroundColor: theme.backgroundBase }}>
            <UsersSelector
              userId={userId}
              selected={selectedUserId}
              onUserSearch={(e) => {
                setSelectedUserId(null);
              }}
              onUserSelected={(e) => {
                setSelectedUserId(e);
              }}
            />
          </div>
          <div className={'overflow-scroll h-full max-h-full w-full'} style={{ backgroundColor: theme.backgroundBase }}>
            <UsersEditor userId={selectedUserId} onSave={handleUserEditorOnSave} onDelete={handleUserEditorOnDelete} />
          </div>
        </Splitter>
      </div>
    </PermissionsProvider>
  );
};

// MasterAdminUsers.propTypes = {};

export default MasterAdminUsers;
